import envVariables from "../lib/envHelpers/getEnvVariables";
import deepMerge from "../lib/DeepMerge";
import * as configs from "./modules/";

let config = configs["default"];

const vendor = envVariables.CONFIG_VENDOR_KEY || envVariables.VENDOR;
const generalConfigKey = `${vendor}_default`;
const specificConfigKey =
  envVariables.CONFIG_ENV_KEY ||
  `${vendor}_${envVariables.TARGET_ENV || envVariables.NODE_ENV}`;

let vendorConfig = deepMerge(
  configs[generalConfigKey],
  configs[specificConfigKey]
);

// `squaber_development.js` is gitignored and absent from CI builds; avoid a dead env key.
if (!configs[specificConfigKey] && vendor === "squaber" && specificConfigKey.endsWith("_development")) {
  const stagingFallbackKey = `${vendor}_staging`;
  if (configs[stagingFallbackKey]) {
    vendorConfig = deepMerge(configs[generalConfigKey], configs[stagingFallbackKey]);
  }
}

config = deepMerge(config, vendorConfig);

export default config;
